// Server-side cap on notifiable hike highlights per hike. The web POI
// dialog must stay in lockstep with the backend (`Hike#hike_highlights`
// notifiable validation) and with iOS/Android, which all enforce the
// same number. Bumping or lowering this value is a coordinated
// cross-platform change.
export const NOTIFIABLE_HIGHLIGHTS_PER_HIKE_LIMIT = 20;

export interface NotifiableHighlightLike {
  notificationDistance: number | null | undefined;
  clientId?: string | null;
}

// Count the existing notifiable highlights on the hike, ignoring the one
// the user is currently editing (so the edit path doesn't double-count
// the row that's already persisted).
export const countOtherNotifiableHighlights = (
  highlights: readonly NotifiableHighlightLike[],
  excludingClientId?: string | null,
): number =>
  highlights.filter(h =>
    h.notificationDistance != null &&
    h.clientId !== excludingClientId,
  ).length;

// True when adding/saving the current POI as notifiable would push the
// hike past the per-hike cap. Returns false when the current POI is not
// notifiable (notificationDistance is null/undefined) regardless of how
// many other notifiable highlights exist.
export const isNotifiableLimitReached = (
  currentHasNotificationDistance: boolean,
  highlights: readonly NotifiableHighlightLike[],
  excludingClientId?: string | null,
): boolean =>
  currentHasNotificationDistance &&
  countOtherNotifiableHighlights(highlights, excludingClientId) >= NOTIFIABLE_HIGHLIGHTS_PER_HIKE_LIMIT;
